import { all, takeLatest } from 'redux-saga/effects';
import * as categoriesActions from '../actions';
import fetchCategories from './worker.fetchCategories';

function* categoriesSaga() {
  yield all([takeLatest([categoriesActions.fetchCategories.type], fetchCategories)]);
}

export default categoriesSaga;
